angular.module('bmsApp.trugreen.product', [
	'ui.router'
])
	.config([
		'$stateProvider', function config($stateProvider) {

			$stateProvider

				.state('main.trugreen.product', {
					abstract: true
				})

			;

		}]
);
